module.exports = __webpack_public_path__ + "fonts/SegoeUI-Bold.4b6a274.woff";